module.exports = __webpack_public_path__ + "media/images/emblems/Hohenrain_LU-df3e371cba23469055b92209240427ee.png";